module.exports = __webpack_public_path__ + "img/copy-all.833f5b3e.svg";